export type ProjectSuggestionData = {
  accountId?: string | null;
  projectId?: string | null;
  sowId?: string | null;
};

export type ProjectSuggestionRequestData = {
  projectId: string | null;
  accountId: string | null;
  sowId: string | null;
};

const PROJECT_SUGGESTION_ACCOUNT_PREFIXES = ['Expenses/Delivery', 'Expenses/People management'] as const;

const PEOPLE_MANAGEMENT_ACCOUNT_PREFIXES = ['Expenses/People management'] as const;

export const isProjectSuggestionAccount = (account?: string | null): boolean =>
  !!account && PROJECT_SUGGESTION_ACCOUNT_PREFIXES.some(accountPrefix => account.includes(accountPrefix));

export const normalizeProjectForRequest = (project?: ProjectSuggestionData | null): ProjectSuggestionRequestData => {
  if (!project) {
    return {
      projectId: null,
      accountId: null,
      sowId: null,
    };
  }

  const accountId = project.accountId ?? null;

  if (PEOPLE_MANAGEMENT_ACCOUNT_PREFIXES.some(accountPrefix => accountId?.includes(accountPrefix))) {
    return {
      projectId: null,
      accountId,
      sowId: null,
    };
  }

  return {
    projectId: project.projectId ?? null,
    accountId,
    sowId: project.sowId ?? null,
  };
};
